import React from "react";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";

import {setUiPopupState} from "../../../actions/A_Popups";
import {UI_POPUP_TYPES} from "../../../reducers/R_Popups";
import {onSaveReferralProgramsClick} from "../Popups/ReferralPopup/referralPopupApi";


const CentralHubReferralButton = (props) => {

  const {setUiPopupState, onSaveReferralProgramsClick} = props;

  const onButtonClick = () => {
    setUiPopupState({
      headerTextId: "referralPopup.title",
      className: "",
      style: {maxWidth: "920px", maxHeight: "540px"},
      opened: true,
      type: UI_POPUP_TYPES.referral,
      context: {},
      buttons: [{}, {
        className: "ui-button5 ui-button5--wide text-uppercase ui-button5--green",
        textId: "messageBox.buttons.save",
        onClick: onSaveReferralProgramsClick,
      }],
    });
  };

  return (
    <div className="central-hub-icons-flex-item">
      <div className="central-hub-icon-frame central-hub-icon-referral" onClick={onButtonClick}/>
      <span className="central-hub-icons-flex-item__text">
        <FormattedMessage id="centralHub.buttons.referral"/>
      </span>
    </div>
  )
};

const mapStateToProps = (store) => {
  // const {uiPopupState} = store.popups;
  return {
    // uiPopupState
  }
};

const mapDispatchToProps = {
  setUiPopupState,
  onSaveReferralProgramsClick,
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(CentralHubReferralButton)
)
